import axios from 'axios'
import JSZip from 'jszip'
import {toCSV} from 'shared/csv';
import moment from 'moment'
var FileSaver = require('file-saver');

function loadMedia(story){
  return axios.get(story.url+"&v="+Math.random(1000000),
    { responseType:"blob" }
  ).then(res=>({
    data:res.data,
    name:moment(story.posted_at).format('YYYY-MM-DD h:mm')+(story.type==="VIDEO" ? ".mp4" : ".jpg")
  }))
}

function zipFiles(filename, csvFile, files){
  var zip = new JSZip();
  var zipFolder = zip.folder(filename);
  zipFolder.file("export.csv", csvFile)
  files.forEach((file,index)=>{
    zipFolder.file(file.name, file.data, {base64: true});
  })
  zip.generateAsync({type:"blob"})
  .then(function(content) {
      // see FileSaver.js
      FileSaver.saveAs(content, filename+".zip");
  });
}

function createCSVFile(stories){
  let data=[
    ["posted_at","type","impressions","reach","replies","exits","taps_forward","taps_back","url"]
  ]
  stories.forEach(s=>data.push([s.posted_at, s.type, s.insights.impressions, s.insights.reach, s.insights.replies, s.insights.exits, s.insights.taps_forward, s.insights.taps_back, s.url]))
  return toCSV(data)
}



const zipMiddleware = store => next => action => {
  switch(action.type){
    case "DOWNLOAD_STORY_ZIP":
    case "EXPORT_ALL":
      let csvFile=createCSVFile(action.payload.stories)
      Promise.all(action.payload.stories.map(loadMedia)).then(mediaFiles=>zipFiles(action.payload.fileName, csvFile, mediaFiles))
      break;
    default:
      next(action)
  }
}

export default zipMiddleware



// WEBPACK FOOTER //
// ./src/utils/middlewares/zip.js